import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { constants } from '../../../../config/constants';
import FeatureHighlighter from '../../../ui/FeatureHighlighter/FeatureHighlighter';
import Switch from '../../../ui/Switch/Switch';
import { facetClick } from '../../FacetEvents';
import { styles } from './FacetWithSwitch.style';

const FacetWithSwitch = ({
  item,
  onFacetChange,
  withIcon,
  type,
  appCtx,
  isMobileFacetUI,
  inMultiselect,
  isInDrawer,
}) => {
  const [data, setData] = useState(item?.values?.[0]);
  const [localSelected, setLocalSelected] = useState(item?.values?.[0]?.selected || false);
  const facetLabeles = appCtx?.siteConfig?.facetLabels ?? '';
  const { deviceType } = appCtx || {};
  const isMobile = deviceType === 'mobile' || deviceType === 'tablet';

  useEffect(() => {
    setData(item?.values?.[0]);
    setLocalSelected(item?.values?.[0]?.selected || false);
  }, [item?.values]);

  const handleSwitchChange = () => {
    facetClick();
    if (isMobile && isInDrawer) {
      const newSelected = !localSelected;
      setLocalSelected(newSelected);
      onFacetChange({
        ...data,
        selected: newSelected,
        isSwitchFacet: true,
        isMobileDrawer: true,
      });
    } else {
      onFacetChange({ ...data, selected: !data?.selected, isSwitchFacet: true });
    }
  };

  if (!data) {
    return null;
  }

  const isNextDayFacet = type === 'shipping' && data.title === 'Llega mañana';
  const isEventFacet = type === 'event';
  const isChecked = isMobile && isInDrawer ? localSelected : data.selected;

  return (
    <div
      data-facet-type={data.facetType}
      className={`facet-with-switch${isMobileFacetUI ? ' event-mobile-container' : ''} ${type} ${
        isChecked ? 'selected' : ''
      }${inMultiselect ? ' in-multiselect' : ''}`}
    >
      <div className="heading-section">
        {withIcon && (
          <div className="icon-container">
            <i className="icon" />
          </div>
        )}
        <div className={`heading ${type}${isMobileFacetUI ? ' event-mobile' : ''}`}>
          <p>{data?.title?.toLowerCase() === constants.LO_ULTIMO ? '🔥 lo.último' : data.title}</p>
          <FeatureHighlighter component="facets" id={data.title} />
        </div>
        {isEventFacet && isMobileFacetUI && facetLabeles[`${data.facetType}`] && (
          <div
            className="label-section event-mobile"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: facetLabeles[`${data.facetType}`].replace(/<strong/gi, "<strong style='font-weight: bold'"),
            }}
          />
        )}
        <div className="switch-container">
          <Switch
            id={`facet-swich-${data?.facetType}`}
            isChecked={isChecked}
            onChange={handleSwitchChange}
            manageState={false}
            type={type}
          />
        </div>
      </div>
      {!isNextDayFacet && !isMobileFacetUI && facetLabeles[`${data.facetType}`] && (
        <div
          className="label-section"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: facetLabeles[`${data.facetType}`].replace(/<strong/gi, "<strong style='font-weight: bold'"),
          }}
        />
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

FacetWithSwitch.defaultProps = {
  type: '',
  isMobileFacetUI: false,
  appCtx: {},
  inMultiselect: false,
  isInDrawer: false,
};
FacetWithSwitch.propTypes = {
  item: PropTypes.object.isRequired,
  onFacetChange: PropTypes.func.isRequired,
  withIcon: PropTypes.bool.isRequired,
  type: PropTypes.string,
  isMobileFacetUI: PropTypes.bool,
  appCtx: PropTypes.object,
  inMultiselect: PropTypes.bool,
  isInDrawer: PropTypes.bool,
};
export { FacetWithSwitch };
